module.exports = __webpack_public_path__ + "media/images/elisa_niccolai-b35eb051bfa7a44358828ac80718ea59.jpg";